<div *transloco="let t">
	<vex-page-layout mode="card">
		<vex-page-layout-header class="pb-16 flex flex-col justify-center items-start">
			<div class="mt-4">
				<h1 class="title mt-0 mb-1">{{ t('realestates.tenantunits') }}</h1>
				<vex-breadcrumbs [crumbs]="breadCrumbService.crumbs"></vex-breadcrumbs>
			</div>
		</vex-page-layout-header>
		<vex-page-layout-content class="-mt-6">
			<ara-tenant-detail-cards></ara-tenant-detail-cards>

			<div class="flex items-start gap-4 mt-5 mb-5">
				@if (sessionService.isPropertyManagement() || sessionService.isDevRole() || sessionService.isSupportRole()) {
					<button (click)="openConsumptionInformations()" [matTooltip]="t('consumptionInformation.tooltip')" color="primary" mat-raised-button>
						<mat-icon [svgIcon]="icons.get('consumptionInfo')"></mat-icon>
					</button>
				}

				@if (sessionService.isDevRole() && billings().length > 0) {
					<div class="re-billing-chips-container">
						@for (billing of billings(); track billing.exportId) {
							@if (getRecentPeriods(billing); as recentPeriods) {
								@if (recentPeriods.length > 0) {
									@for (period of recentPeriods; track $index) {
										<div class="re-billing-chip">
											<div class="re-billing-chip-content">
												@if (isSubmitted(period)) {
													<mat-icon class="re-billing-status-icon re-billing-status-submitted">check_circle</mat-icon>
												} @else if (isActive(period)) {
													<mat-icon class="re-billing-status-icon re-billing-status-active">pending</mat-icon>
												}
												<div class="re-billing-chip-info">
													<div class="re-billing-chip-line1">
														@if (billing.billingName) {
															{{ billing.billingName }} {{ billing.billingNumber }}
														} @else {
															{{ t('billings.billingNumber') + ' ' + billing.billingNumber }}
														}
													</div>
													<div class="re-billing-chip-line2">
														{{ dateUtil.setDateFormatByActiveLang(period.validFrom, '', false, true) }}
														- {{ dateUtil.setDateFormatByActiveLang(period.validTo, '', false, true) }}
													</div>
												</div>
												<button mat-icon-button (click)="navigateToBilling(billing.exportId)" class="re-billing-open-button">
													<mat-icon>open_in_new</mat-icon>
												</button>
											</div>
										</div>
									}
								} @else {
									<div class="re-billing-chip">
										<div class="re-billing-chip-content">
											<div class="re-billing-chip-info">
												<div class="re-billing-chip-line1">
													@if (billing.billingName) {
														{{ billing.billingName }} {{ billing.billingNumber }}
													} @else {
														{{ t('billings.billingNumber') + ' ' + billing.billingNumber }}
													}
												</div>
												<div class="re-billing-chip-line2 re-no-period">
													{{ t('billing.noPeriod') }}
												</div>
											</div>
											<button mat-icon-button (click)="navigateToBilling(billing.exportId)" class="re-billing-open-button">
												<mat-icon>open_in_new</mat-icon>
											</button>
										</div>
									</div>
								}
							}
						}
					</div>
				}
			</div>

			<div class="card p-4 overflow-auto">
				<div class="bg-app-bar px-6 h-16 border-b sticky left-0 flex flex-row justify-start items-center">
					<h2 class="title my-0 ltr:pr-4 rtl:pl-4 ltr:mr-4 rtl:ml-4 ltr:border-r rtl:border-l hidden xs:block">
						<span>{{ t('sideboard.tenantunits') }}</span>
					</h2>
					<div class="bg-card rounded-full border px-4 bg-white flex flex-row justify-start items-center w-[400px] md:w-auto">
						<mat-icon [svgIcon]="icons.get('search')" size="20px"></mat-icon>
						<input
							#input
							[formControl]="searchValueFC"
							class="px-4 py-3 border-0 outline-none w-full bg-transparent"
							matInput
							name="searchField"
							placeholder="{{ t('commonActions.search') }}"
							type="search" />
					</div>
					<span class="flex-1"></span>

					<button [matMenuTriggerFor]="columnFilterMenu" [matTooltip]="t('commonActions.filterColumns')" class="ml-4" mat-icon-button type="button">
						<mat-icon [svgIcon]="icons.get('filterList')"></mat-icon>
					</button>
				</div>
				<table @stagger [dataSource]="dataSource" class="w-full" mat-table matSort>
					<ng-container matColumnDef="selectForSmokeDetectorCheckPrint">
						<th *matHeaderCellDef mat-header-cell>
							<mat-checkbox
								(change)="$event ? masterToggle() : null"
								[checked]="selection.hasValue() && this.selectToggleEnabled() && allSelected()"
								[indeterminate]="selection.hasValue() && !allSelected()"></mat-checkbox>
						</th>
						<td *matCellDef="let row" mat-cell>
							<mat-checkbox
								(change)="$event ? selection.toggle(row) : null"
								(click)="$event.stopPropagation()"
								(keydown.enter)="$event.stopPropagation()"
								[checked]="selection.isSelected(row)"></mat-checkbox>
						</td>
					</ng-container>
					<ng-container matColumnDef="number">
						<th *matHeaderCellDef mat-header-cell mat-sort-header="number">
							{{ t('common.number') }}
						</th>
						<td *matCellDef="let tenantUnit" [attr.data-label]="t('common.number')" mat-cell>
							@if (tenantUnit.number) {
								{{ tenantUnit.number }} / {{ tenantUnit.subNumber }}
							}
						</td>
					</ng-container>
					<ng-container matColumnDef="location">
						<th *matHeaderCellDef mat-header-cell mat-sort-header="location">
							{{ t('tenantunits.location') }}
						</th>
						<td *matCellDef="let tenantUnit" [attr.data-label]="t('tenantunits.location')" mat-cell>
							@if (tenantUnit.floorType) {
								{{
									tenantUnit.floorType === floorType.GROUND_FLOOR || tenantUnit.floorType === floorType.ATTIC
										? ''
										: math.abs(tenantUnit?.floorNumber) + '.'
								}}
								{{ t('floorType.' + tenantUnit.floorType) }} {{ tenantUnit.location }}
							}
						</td>
					</ng-container>
					<ng-container matColumnDef="apartmentNumber">
						<th *matHeaderCellDef mat-header-cell mat-sort-header="apartmentNumber">
							{{ t('tenantunits.apartmentNumber') }}
						</th>
						<td *matCellDef="let tenantUnit" [attr.data-label]="t('tenantunits.apartmentNumber')" mat-cell>
							{{ tenantUnit.apartmentNumber }}
						</td>
					</ng-container>
					<ng-container matColumnDef="currentOwner">
						<th *matHeaderCellDef mat-header-cell mat-sort-header="activeOwner">
							{{ t('tenantunits.owner') }}
						</th>
						<td *matCellDef="let tenantUnit" [attr.data-label]="t('tenantunits.owner')" mat-cell>
							<div class="flex items-center gap-1">
								@if (isCurrentRole(tenantUnit.currentOwner)) {
									<div class="flex flex-col leading-tight">
										@if (isPropertyManagement()) {
											<button araLink type="button" class="text-sm" (click)="openPersonDialog(tenantUnit, 'OWNER', $event)">
												<span [textContent]="getOwnerDisplayName(tenantUnit)"></span>
											</button>
										} @else {
											<span class="text-sm" [textContent]="getOwnerDisplayName(tenantUnit)"></span>
										}
										<span class="text-xs text-gray-600">{{ getRoleDateRange(tenantUnit.currentOwner) }}</span>
									</div>
								} @else {
									<span class="text-sm text-gray-400">-</span>
								}
								@if (getOwnerHistory(tenantUnit); as ownerHistory) {
									<ara-popover [panelTemplate]="ownerHistoryPanel">
										<button araButton="icon" type="button" class="role-history-btn" [attr.aria-label]="t('tenantunits.roleHistory')">
											<mat-icon fontSet="material-symbols-outlined">history</mat-icon>
										</button>
									</ara-popover>
									<ng-template #ownerHistoryPanel>
										<ara-role-history-popover [history]="ownerHistory" />
									</ng-template>
								}
							</div>
						</td>
					</ng-container>
					<ng-container matColumnDef="currentTenant">
						<th *matHeaderCellDef mat-header-cell mat-sort-header="currentTenant">
							{{ t('tenantunits.tenant') }}
						</th>
						<td *matCellDef="let tenantUnit" [attr.data-label]="t('tenantunitDetails.tenant')" mat-cell>
							<div class="flex items-center gap-1">
								@if (isCurrentRole(tenantUnit.currentTenant)) {
									<div class="flex flex-col leading-tight">
										<button araLink type="button" class="text-sm" (click)="openPersonDialog(tenantUnit, 'TENANT', $event)">
											<span [textContent]="getTenantDisplayName(tenantUnit)"></span>
										</button>
										<span class="text-xs text-gray-600">{{ getRoleDateRange(tenantUnit.currentTenant) }}</span>
									</div>
								} @else {
									<span class="text-sm text-gray-400">-</span>
								}
								@if (getTenantHistory(tenantUnit); as tenantHistory) {
									<ara-popover [panelTemplate]="tenantHistoryPanel">
										<button araButton="icon" type="button" class="role-history-btn" [attr.aria-label]="t('tenantunits.roleHistory')">
											<mat-icon fontSet="material-symbols-outlined">history</mat-icon>
										</button>
									</ara-popover>
									<ng-template #tenantHistoryPanel>
										<ara-role-history-popover [history]="tenantHistory" />
									</ng-template>
								}
							</div>
						</td>
					</ng-container>
					<ng-container matColumnDef="currentResident">
						<th *matHeaderCellDef mat-header-cell mat-sort-header>
							{{ t('tenantunits.resident') }}
						</th>
						<td *matCellDef="let tenantUnit" [attr.data-label]="t('tenantunits.resident')" mat-cell>
							<div class="flex items-center gap-1">
								@if (isCurrentRole(tenantUnit.currentResident)) {
									<div class="flex flex-col leading-tight">
										<button araLink type="button" class="text-sm" (click)="openPersonDialog(tenantUnit, 'RESIDENT', $event)">
											<span [textContent]="getResidentDisplayName(tenantUnit)"></span>
										</button>
										<span class="text-xs text-gray-600">{{ getRoleDateRange(tenantUnit.currentResident) }}</span>
									</div>
								} @else {
									<span class="text-sm italic text-gray-400" [textContent]="t('tenantunitDetails.vacancy')"></span>
								}
								@if (getResidentHistory(tenantUnit); as residentHistory) {
									<ara-popover [panelTemplate]="residentHistoryPanel">
										<button araButton="icon" type="button" class="role-history-btn" [attr.aria-label]="t('tenantunits.roleHistory')">
											<mat-icon fontSet="material-symbols-outlined">history</mat-icon>
										</button>
									</ara-popover>
									<ng-template #residentHistoryPanel>
										<ara-role-history-popover [history]="residentHistory" />
									</ng-template>
								}
							</div>
						</td>
					</ng-container>
					<ng-container matColumnDef="uviDelivery">
						<th *matHeaderCellDef mat-header-cell mat-sort-header="uviDelivery">uVI</th>
						<td *matCellDef="let tenantUnit" [attr.data-label]="'uVI'" mat-cell>
							<div class="flex items-center gap-1">
								<mat-icon
									class="text-gray-500 text-[20px] w-5 h-5"
									fontSet="material-symbols-outlined"
									[matTooltip]="t('uviOptions.' + (receptionTypes[tenantUnit.id] !== undefined ? receptionTypes[tenantUnit.id] : 'NO_EED'))">
									{{ getUviIcon(receptionTypes[tenantUnit.id]) }}
								</mat-icon>
								<ara-popover [content]="t(uviJumpTooltipKey(tenantUnit))">
									<button
										araButton="icon"
										color="secondary"
										type="button"
										class="uvi-jump-button"
										(click)="routeToUvi(tenantUnit, $event)"
										[disabled]="!canJumpToUvi(tenantUnit)"
										[attr.aria-label]="t('uvi.jumpToUvi')">
										<mat-icon fontSet="material-symbols-outlined">speed</mat-icon>
									</button>
								</ara-popover>
							</div>
						</td>
					</ng-container>
					<ng-container matColumnDef="address">
						<th *matHeaderCellDef mat-header-cell mat-sort-header="address">
							{{ t('address.street') }}
						</th>
						<td *matCellDef="let tenantUnit" [attr.data-label]="t('address.street')" mat-cell>
							{{ tenantUnit.address?.streets[0]?.streetName }} {{ tenantUnit.address?.streets[0]?.houseNumber }}
							{{ tenantUnit.address?.streets[1]?.streetName }} {{ tenantUnit.address?.streets[1]?.houseNumber }}
						</td>
					</ng-container>

					<ng-container matColumnDef="inspectionState">
						<th *matHeaderCellDef mat-header-cell mat-sort-header>
							{{ t('smokeDetectorCheck.inspectionState') }}
						</th>
						<td
							*matCellDef="let row"
							[attr.data-label]="t('enum.' + row.inspectionState)"
							[matTooltip]="row.nextExecutionDate"
							[matTooltipDisabled]="row.inspectionState !== 'IN_PROGRESS'"
							mat-cell>
							<mat-icon
								[class]="iconHelper.getColorByInspectionState(row.inspectionState, row.operationalState)"
								[svgIcon]="iconHelper.getIconByInspectionState(row.inspectionState, row.operationalState)"></mat-icon>
						</td>
					</ng-container>

					<tr *matHeaderRowDef="visibleColumns" mat-header-row></tr>
					<tr
						(click)="onTenantUnitDetail(row)"
						(keydown.enter)="onTenantUnitDetail(row)"
						*matRowDef="let row; columns: visibleColumns"
						@fadeInUp
						class="hover:bg-hover trans-ease-out cursor-pointer"
						mat-row></tr>

					<!-- Row shown when there is no matching data. -->
					<tr *matNoDataRow class="mat-row">
						<td class="mat-cell" colspan="4">
							<div class="ml-4">
								{{ t('dashboard.noDataFound') }}
							</div>
						</td>
					</tr>
				</table>
				<ara-paginator
					[pageSizeOptions]="pageSizeOptions"
					[showFirstLastButtons]="true"
					[attr.aria-label]="t('common.choosePage')"
					class="sticky left-0"></ara-paginator>
			</div>
		</vex-page-layout-content>
	</vex-page-layout>
	@if (!finishedLoading()) {
		<div @fadeInUp class="flex flex-row justify-center">
			<mat-spinner color="primary"></mat-spinner>
		</div>
	}
</div>
<mat-menu #columnFilterMenu="matMenu" xPosition="before" yPosition="below">
	<div class="grid grid-rows grid-cols-1">
		@for (column of columns; track column) {
			<button (click)="toggleColumnVisibility(column, $event)" class="checkbox-item mat-menu-item text-left">
				<mat-checkbox (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()" [(ngModel)]="column.visible" color="primary">
					{{ column.label }}
				</mat-checkbox>
			</button>
		}
	</div>
</mat-menu>
